import { combineReducers } from "redux";
import homeReducer from "./home/home.reducer";
import signUpReducer from "./signUp/signUp.reducer";
import signInReducer from "./signIn/signIn.reducer";

export const rootReducer = combineReducers({
  home: homeReducer,
  signUp: signUpReducer,
  signIn: signInReducer,
});
